<template>
  <div class="row">
    <div class="col-md-8 col-md-offset-2 general-active-section">
      <h3 class="text-center">
        {{computeCaption(fields_en['account_settings'], $store.state.lang.value.toLowerCase())}}
      </h3>
      <br />
      <div v-if="$store.state.sitecode !== false" class="row">
        <div class="col-md-10 col-md-offset-1 bg-white text-center-mobile">
          <label
            class="control-label"
            for="siteCode"
            v-html="computeCaption(fields_en['office_location_code'], $store.state.lang.value.toLowerCase())"
          >
          </label>
          <el-input
            placeholder="Ex:12345678"
            v-model="sitecode"
            class="input-with-select"
            :disabled="disableSiteCodeButton"
          >
            <button
              slot="append"
              class="btn btn-fill btn-wd btn-next text-center"
              @click.stop.prevent="updateSiteCode()"
              :disabled="disableSiteCodeButton"
            >
              {{computeCaption(fields_en['update_sitecode'], $store.state.lang.value.toLowerCase())}}
            </button>
          </el-input>
          <small class="text-danger" v-show="sitecodeError">
            {{sitecodeError && computeCaption(sitecodeError, $store.state.lang.value.toLowerCase())}}
          </small>
          <small class="text-primary" v-show="sitecodeMessage">
            {{sitecodeMessage && computeCaption(sitecodeMessage, $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
      <br />
      <br />

      <div v-show="this.$store.state.configs.ALLOW_LANGUAGES" class="row">
        <div class="col-md-10 col-md-offset-1 bg-white text-center-mobile">
          <language-button-group></language-button-group>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-md-10 col-md-offset-1 bg-white">
          <button
            @click="deleteAdditionQuestion = true"
            class="btn btn-fill btn-wd w-100 btn-red text-center"
          >
            {{computeCaption(fields_en['delete_account'], $store.state.lang.value.toLowerCase())}}
          </button>
        </div>
      </div>
      <br />
      <div class="row" v-if="deleteAdditionQuestion">
        <div class="col-md-10 col-md-offset-1">
            <div class="row">
              <div class="col-md-4 col-sm-4 col-xs-12 text-center-mobile">
                <label
                  class="control-label"
                  for="deleteAccount"
                  v-html="computeCaption(fields_en['are_you_sure_you_want_to_delete_your_account'], $store.state.lang.value.toLowerCase())"
                ></label>
              </div>
              <div class="col-xs-1 display-big-none"></div>
              <div class="text-right-big-device">
                <div class="col-md-4 col-sm-4 col-xs-5 text-right-big-device">
                  <button
                    @click="deleteAdditionQuestion = false"
                    class="btn btn-fill btn-wd btn-wd-xsmall btn-back wd-mobile-100 text-center"
                  >
                    {{computeCaption(fields_en['no'], $store.state.lang.value.toLowerCase())}}
                  </button>
                </div>
                <div class="col-md-4 col-sm-4 col-xs-5 text-right-big-device">
                  <button
                    @click="deleteAccount()"
                    class="btn btn-fill btn-wd wd-mobile-100 btn-wd-xsmall btn-next text-center"
                  >
                    {{computeCaption(fields_en['yes'], $store.state.lang.value.toLowerCase())}}
                  </button>
                </div>
              </div>
            <br />
          </div>
        </div>
        <br /><br />
      </div>
      <div class="row">
        <br />
        <div class="col-md-10 col-md-offset-1 bg-white">
          <button
            class="btn btn-fill btn-wd btn-back text-center"
            @click.stop.prevent="goBack()"
          >
            {{computeCaption(fields_en['back'], $store.state.lang.value.toLowerCase())}}
          </button>
        </div>
      </div>
    </div>
    <br />
  </div>
</template>


<script>
import {Autocomplete, Input, Drawer, Button, RadioGroup, Radio, RadioButton, DatePicker, Checkbox} from 'element-ui'
import LanguageButtonGroup from '../../LanguageButtonGroup'
import axios from 'axios'
import swal from 'sweetalert2'
import {TranslationsUtils} from '../../../../../utils/Translations'
import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
export default {
  components: {
    [Input.name]: Input,
    [DatePicker.name]: DatePicker,
    [Autocomplete.name]: Autocomplete,
    [Drawer.name]: Drawer,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [Checkbox.name]: Checkbox,
    LanguageButtonGroup
  },
  mixins: [TranslationsUtils, SettingsUtils],
  data () {
    return {
      deleteAdditionQuestion: false,
      disableSiteCodeButton: false,
      sitecodeMessage: '',
      fields_en: {
        back: 'Back',
        update_sitecode: 'Update Sitecode',
        account_settings: 'Account settings',
        office_location_code: 'Office Location Code',
        delete_account: 'Delete Account',
        are_you_sure_you_want_to_delete_your_account: 'Are you sure you want to delete your account?',
        yes: 'Yes',
        no: 'No'
      },
      sitecode: '',
      sitecodeError: ''
    }
  },
  methods: {
    redirectHome () {
      const body = document.querySelector('body')
      const self = this
      body.onclick = function () {
        self.$router.push({ path: '/' })
      }
    },
    async deleteAccount () {
      await axios({
        url: process.env.SERVER_URI + '/account/delete/account',
        method: 'post',
        data: {access_token: localStorage.getItem('access_token'), email: localStorage.getItem('email')},
        headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`}
      })
      .then((response) => {
        localStorage.clear()
        swal('Account Deleted!', 'Your account has been successfully deleted!', 'success')
        this.redirectHome()
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    updateSiteCode () {
      if (!this.sitecodeError) {
        this.disableSiteCodeButton = true
        let one = process.env.SERVER_URI + '/account/update/sitecode'
        let email = localStorage.getItem('email')
        const requestOne = axios.post(one, {'email': email, 'code': this.sitecode}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        axios.all([requestOne])
            .then(axios.spread((...responses) => {
              if (responses[0].data) {
                this.$store.state.sitecode = this.sitecode
                this.sitecodeMessage = 'SiteCode updated'
              } else {
                this.disableSiteCodeButton = false
                this.sitecodeError = 'Invalid Sitecode'
              }
            })).catch(error => {
              console.log(error)
            })
      }
    },
    buttonClick () {
      this.buttonClicked = true
    },
    buttonClickLogOut () {
      this.buttonClicked = true
      localStorage.removeItem('token')
      localStorage.removeItem('email')
    },
    goBack () {
      this.$router.push('/patient/account')
    }
  },
  computed: {
    title () {
      return this.$store.state.configs.LAB_NAME
    }
  },
  beforeMount () {
    this.sitecode = this.$store.state.sitecode || ''
    if (this.sitecode && this.sitecode.length >= 2) {
      axios.get(process.env.SERVER_URI + '/validate/site/' + this.sitecode).then(async (response) => {
        if (response.data === false) {
          this.sitecodeError = 'Invalid sitecode'
        } else {
          this.overwriteGraphSettings(response.data)
        }
      })
    }
  },
  watch: {
    'sitecode': {
      handler (before, after) {
        if (this.sitecode.length < 2) {
          this.sitecodeError = 'SiteCode must have at least 2 characters'
        } else {
          this.sitecodeError = ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";
.general-active-section {
  padding-bottom: 40px;
}
.pt-15 {
  padding-top: 15px;
}
.btn-next {
  border: 1px solid $primary-color !important;
  border-radius: 3px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.btn-red {
  background-color: $danger-states-color !important;
  border-color: $danger-states-color !important;
  color: white !important;
  border-radius: 4px;
  height: 40px;
}

.btn-red:hover {
  background-color: $danger-states-color !important;
  color: white !important;
}

.w-100 {
  width: 100%;
}
.pt-50 {
  padding-top: 50px
}
.mg-l-10 {
  margin-left: 40px !important;
}
.text-center-mobile {
  text-align: left;
}
.text-right-big-device{
  text-align: right;
}
.display-big-none {
  display: none;
}
@media screen and (max-width: 991px) {
  .w-100-mobile {
    width: 100%;
  }
  .mg-t-10 {
    margin-top: 10px;
  }
  .display-big-none {
    display: none;
  }
}
@media screen and (max-width: 480px) {
  .text-center-mobile {
    text-align: center;
  }
  .display-big-none {
    display: block;
  }
}
@media screen and (max-width: 776px) {
  .text-center-mobile {
    text-align: center !important;
  }
  .text-right-big-device {
    text-align: center;
  }
  .display-big-none {
    display: block;
  }
}
@media screen and (max-width: 360px) {
  .wd-mobile-100 {
    width:100%;
  }
  .btn-wd-xsmall {
    min-width: 80px !important
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/ManageAccount.vue